import { createContext, useContext, useState, ReactNode } from "react";
import {
  SPIFF_SIDEBAR_SECTIONS,
  SpiffSidebarSection,
} from "@/spiffs/constants";
import type { EnrichedGroupedPeriodSpiffs } from "@/spiffs/spiffs.d";

interface SpiffSidebarState {
  isOpen: boolean;
  section: SpiffSidebarSection;
  selectedItemId: string | null;
  metadata?: {
    payrollPeriod?: EnrichedGroupedPeriodSpiffs;
  };
}

interface SpiffSidebarContextType {
  state: SpiffSidebarState;
  updateSidebar: (update: Partial<SpiffSidebarState>) => void;
  resetSidebar: () => void;
}

const initialState: SpiffSidebarState = {
  isOpen: false,
  section: SPIFF_SIDEBAR_SECTIONS.pendingSpiffs,
  selectedItemId: null,
  metadata: undefined,
};

const SpiffSidebarContext = createContext<SpiffSidebarContextType>({
  state: initialState,
  updateSidebar: () => {},
  resetSidebar: () => {},
});

interface SpiffSidebarProviderProps {
  children: ReactNode;
}

export const SpiffSidebarProvider = ({
  children,
}: SpiffSidebarProviderProps) => {
  const [state, setState] = useState<SpiffSidebarState>(initialState);

  const updateSidebar = (update: Partial<SpiffSidebarState>) => {
    setState((current) => ({
      ...current,
      ...update,
    }));
  };

  const resetSidebar = () => {
    setState(initialState);
  };

  return (
    <SpiffSidebarContext.Provider
      value={{ state, updateSidebar, resetSidebar }}
    >
      {children}
    </SpiffSidebarContext.Provider>
  );
};

export const useSpiffSidebar = (): SpiffSidebarContextType =>
  useContext(SpiffSidebarContext);
